import { render, staticRenderFns } from "./BtnHeader.vue?vue&type=template&id=75b19a96&"
import script from "./BtnHeader.vue?vue&type=script&lang=js&"
export * from "./BtnHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports